export const setEditedVersionValue = (data) => ({
  type: 'EDITED',
  payload: data,
});

export const setAddeddVersionValue = (data) => ({
  type: 'ADDED',
  payload: data,
});
